import $ from 'jquery'
const preloaderSelector = ".custom-lazy-preloader"
const lazyContentCardSelector = ".content-lazy-card"
const lazyCardImageSelector = lazyContentCardSelector + " img[loading='lazy']"
const listenerAttacchedAttribute = 'listener'

function processLazyPreloader(imgEl){
    const contCover = $(imgEl).closest(lazyContentCardSelector) 
    contCover.find(preloaderSelector).remove()
}

export function processImageElement(imageEl){
    if (imageEl.complete) {
        processLazyPreloader(imageEl);
    } else {
        imageEl.setAttribute(listenerAttacchedAttribute, 'true');
        imageEl.addEventListener('load', e => {
            processLazyPreloader(e.target);
        });
    }
}

export function initCardLazyLoad(){
    const lazyElements = document.querySelectorAll(lazyCardImageSelector);
    lazyElements.forEach(imageEl => {
        processImageElement(imageEl)
      }
    );
}

export function updateCardLazyLoad(){
    const lazyElements = document.querySelectorAll(lazyCardImageSelector);
    lazyElements.forEach(imageEl => {
        if (imageEl.getAttribute(listenerAttacchedAttribute) !== 'true'){
            processImageElement(imageEl)
        }
      }
    );
}